(function () {
  'use strict';

  function contactUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return /^\/fr(?:\/|$)/.test(root) ? '/fr/pages/nous-joindre' : '/pages/contact';
  }

  function updateSizeHelpLink() {
    var links = document.querySelectorAll('.ag-size-help a');
    var url = contactUrl();
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href') !== url) links[i].setAttribute('href', url);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSizeHelpLink);
  } else {
    updateSizeHelpLink();
  }

  document.addEventListener('shopify:section:load', updateSizeHelpLink);
  document.addEventListener('shopify:block:select', updateSizeHelpLink);

  if (window.MutationObserver) {
    new MutationObserver(updateSizeHelpLink).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
